/**
 * TanStack Query hooks for `cap-utilization-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	capUtilizationWidgetQueryKeys,
	type CreateCapUtilizationWidgetBody,
	type ListCapUtilizationWidgetParams,
	type ListCapUtilizationWidgetResponse,
	type CapUtilizationWidgetRow,
} from "./api";

export function useCapUtilizationWidgetList(
	params?: ListCapUtilizationWidgetParams,
): UseQueryResult<ListCapUtilizationWidgetResponse, Error> {
	return useQuery({
		queryKey: capUtilizationWidgetQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function useCapUtilizationWidgetCreate(): UseMutationResult<
	CapUtilizationWidgetRow,
	Error,
	CreateCapUtilizationWidgetBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capUtilizationWidgetQueryKeys.all });
		},
	});
}
